module.exports = __webpack_public_path__ + "static/media/instagram_icon.b407fa10.png";